import React, { useEffect} from "react";
import { ReactComponent as VectorImage } from "../../assets/images/module.svg";
import VectorDrop from "../../assets/images/module-arrow.png";
import SelfLearningSubmenu from "./SelfLearningSubmenu";
import "./SelfLearning.scss";
import { useStyles, useTranslations } from "examsbook-react-sdk/custom-hooks";
import { selfLearningVideoUrl, toggleBottomBar } from "examsbook-react-sdk/actions";
import { useDispatch} from "react-redux";
import { Box, Button, Typography, useMediaQuery } from "@material-ui/core";
import { useTheme } from "../../constants/themeProvider";
import { setDataId, setSectionId } from "examsbook-react-sdk/actions/getSelfLearningAction";
import { ReactComponent as GreenTick } from "../../assets/images/greenTick.svg";
import whiteTick from "../../assets/images/whiteTick.png";
import LockIcon from '@material-ui/icons/Lock';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { CircularProgressbar } from "react-circular-progressbar";
import PropTypes from 'prop-types';
import { useTheme as useMuiTheme } from "@material-ui/core/styles";
import { setCourseName, setCourseProgress, setShowEvaluationTestAction } from "examsbook-react-sdk/actions/getCourses";

export default function SelfLearningCard({ courseName, isDropdownOpen, setIsDropdownOpen, sectionIndex, currentSectionIndex, setCurrentSectionIndex, currentDataIndex, setCurrentDataIndex, selectedSubmenu, setSelectedSubmenu, activeIndex, nextClick, setActiveIndex, index, setCurrentActiveSection, currentActiveSection, setSectionChanged, pdfOpen, openPdfViewer, onPdfOpen, courseId, setShowEvaluationTest, showEvaluationTest, sectionName,courseDataList, isDropDown, setIsDropDown, sectionData, setSectionNumber, setNextClick, setCourseDataList, setSectionName,sectionNumber, handleUpdateCourseProgress,   ...props }) {
  const t = useTranslations();
  const dispatch = useDispatch();
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));
  const theme = useTheme();

  const styles = {
    genustext: {
      color: "#000000DE",
      fontWeight: 400,
      margin: 0,
      fontSize: isMobile ? "14px" : "16px",
      textTransform: 'capitalize',
      "@media (max-width: 959px)": {
        margin: 'revert'
      }
    },
    timeContent: {
      fontSize: "14px",
      fontWeight: 500,
      width: '40%',
      textAlign: 'right',
      color: '#000000B2'
    },
    selfLearningBox: {
      borderRadius: '4px',
      background: '#FFFFFF',
      margin: '15px 16px',
      display: 'flex',
      flexDirection: 'column',
    },
    selfLearning:{
      border: `1px solid ${theme?.primaryColor}`,
      color: `${theme?.primaryColor}`,
      fontWeight: '600',
      textTransform: 'capitalize',
      backgroundColor: 'transparent',
      boxShadow:'inherit',
    },
    completedPercentageDiv: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    completedPercentageText: {
      color: '#2E7D32',
      fontWeight: '600'
    },
    readTimeText: {
      fill: '#616161',
      height: '20px',
      width: '20px'
    },
    sectionPercentDiv: {
      width: '-webkit-fill-available',
      background: '#eff2f3',
      gap: '6px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
  };

  const classes = useStyles(styles)();

  const processSectionData = (index) => {
    const newSectionData = sectionData?.data;
    newSectionData?.section?.forEach((section, sectionIndex) => {
      if (sectionIndex >= index) {
        setSectionNumber((prevState) => [
          ...prevState,
          section.courseSectionData.length,
        ]);
        if (sectionIndex === index) {
          setSectionName(section?.title?.en);
          const sectionData = [...section?.courseSectionData];
          setNextClick([
            {
              ...sectionData[0],
              sectionId: section?._id,
              title: section?.title,
            },
          ]);
          sectionData.shift();
          setIsDropDown((prevState) => ({
            ...prevState,
            [sectionIndex]: true,
          }));
        } else {
          setIsDropDown((prevState) => ({
            ...prevState,
            [sectionIndex]: false,
          }));
        }
        setCourseDataList((prevState) => [
          ...prevState,
          ...section?.courseSectionData.map((data1) => ({
            ...data1,
            sectionId: section?._id,
            title: section?.title,
          })),
        ]);
      }
    });
  };

  useEffect(() => {
    if (currentSectionIndex !== index) {
      setIsDropDown((prevState) => ({
        ...prevState,
        [index]: false,
      }));
    }
  }, [currentSectionIndex, index, setIsDropDown]);

  const handleSubmenuAutoClick = (item, sectionIndex, sectionId, courseName) => {
    const courseId = item?.courseId || item?.section?.data?.courseId?._id;

    setCurrentDataIndex(0);
    setCurrentSectionIndex(sectionIndex);
    setSelectedSubmenu(item._id);
    dispatch(setSectionId(sectionId));
    dispatch(setDataId(item._id));
    dispatch(setCourseName(courseName));

    if (item.refModel === "RecordedVideo") {
      dispatch(selfLearningVideoUrl(item));
      setSectionChanged(false);
    } else if (item.refModel === "TextNotes" || item.refModel === "PdfNotes") {
      const data = {
        sectionId,
        dataId: item._id,
        percent: 100,
        courseId,
        isRead: true
      };
      handleUpdateCourseProgress(data);

      if (item.refModel === "PdfNotes") {
        onPdfOpen(!pdfOpen);
        openPdfViewer(item?.contentData?.featured);
      } else {
        dispatch(selfLearningVideoUrl(item));
      }
    }

    if (props.onSubmenuClick) {
      props.onSubmenuClick(props);
    }
  };

  function formatReadTime(minutes) {
    if (!minutes && minutes !== 0) return "";
    
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;

    if (hrs > 0 && mins > 0) {
      return `${hrs} hr ${mins} min`;
    } else if (hrs > 0) {
      return `${hrs} hr`;
    } else {
      return `${mins} min`;
    }
  }
  
  const isLocked = props.data?.locked === true;

  const toggleDropdown = (activeItem, event, index) => {
    event.stopPropagation();
    if (isLocked) return;
  
    const isCurrentlyOpen = currentSectionIndex === index;
  
    if (!isCurrentlyOpen) {
      // Open new section
      setCurrentSectionIndex(index);
      processSectionData(index);
      setSectionChanged(true);
  
      // Reset submenu state
      setSelectedSubmenu(null);
      setCurrentDataIndex(0);
  
      setIsDropDown(prev => ({ ...prev, [index]: true }));
  
      const sectionDataArray = activeItem?.data?.courseSectionData || [];
  
      const firstItem = sectionDataArray.find(
        (item) =>
          item.refModel === "RecordedVideo" ||
          item.refModel === "TextNotes" ||
          item.refModel === "PdfNotes"
      );
  
      if (firstItem) {
        setTimeout(() => {
          handleSubmenuAutoClick(firstItem, index, activeItem?.data._id, courseName);
        }, 100);
      }
    }
  };           
  function handleViewClick(index, courseProgress, sectionId) {
    if (isLocked) return;
    processSectionData(index);
    dispatch(setCourseProgress(courseProgress));
    setCurrentSectionIndex(index);
    setCurrentDataIndex(0);
    dispatch(setSectionId(sectionId))
    dispatch(setCourseName(courseName));
    dispatch(setShowEvaluationTestAction(true));
    setShowEvaluationTest(true);
    dispatch(toggleBottomBar(true));
}

  return (
    <>
      {showEvaluationTest ? (
        <Box>
          <Box
            style={{
              borderTop: '1px solid #e7e7e75d',
              borderBottom: '1px solid #e7e7e75d',
              minHeight: '20px',
              cursor: isLocked ? 'not-allowed' : 'pointer',
              padding: '5px',
              transition: '0.3s all linear',
              opacity: isLocked ? 0.6 : 1,
            }}
            onClick={(event) => toggleDropdown(props, event, index)}
          >
            <Box className="innerBox1">
              <Box className="button-box1">
                {isLocked ? (
                  <LockIcon style={{ fontSize: '18px', color: '#9e9e9e' }} />
                ) : (
                  <Box
                    component="img"
                    style={{ height: '8px', width: '14px' }}
                    className={currentSectionIndex === index ? 'arrow-down' : 'arrow-up'}
                    src={VectorDrop}
                  />
                )}
              </Box>
              <Box className="card1">
                <Box className="content-box1">
                  <p className={classes.genustext} sx={{ m: 0, mb: 1 }}>
                    {props.data?.title?.en}
                  </p>
                </Box>
              </Box>
              {isLocked ? (
                <Box className={classes.timeContent} style={{ color: '#9e9e9e' }}>
                  <LockIcon style={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '4px' }} />
                  {t('Locked')}
                </Box>
              ) : (
                <Box className={classes.timeContent}>{formatReadTime(props?.data?.sectionReadTimeCount)}</Box>
              )}
            </Box>
          </Box>
          {(currentSectionIndex === index) && !isLocked && (
        <Box className="dropdown-content">
          {props.data?.courseSectionData !== undefined ? (
            props.data?.courseSectionData.map((item, index) => (
              <SelfLearningSubmenu
                key={index}
                index={index}
                sectionIndex={sectionIndex}
                data={item}
                section={sectionData}
                courseId={courseId}
                handleUpdateCourseProgress={handleUpdateCourseProgress}
                sectionId={props.data._id}
                setSectionChanged={setSectionChanged}
                pdfOpen={pdfOpen}
                onPdfOpen={onPdfOpen}
                activeItem={props?.activeItem}
                selectedSubmenu={selectedSubmenu}
                setSelectedSubmenu={setSelectedSubmenu}
                nextClick={nextClick}
                sectionName={sectionName}
                onSubmenuClick={props.onSubmenuClick}
                currentSectionIndex = {currentSectionIndex}
                setCurrentSectionIndex = {setCurrentSectionIndex}
                currentDataIndex = {currentDataIndex}
                setCurrentDataIndex={setCurrentDataIndex}
                openPdfViewer={openPdfViewer}
              />
            ))
          ) : (
            <></>
          )}
        </Box>
      )}
        </Box>
      ) : (
        <Box className={classes.selfLearningBox}
          style={{ opacity: isLocked ? 0.6 : 1 }}
        >
          <Box
            className="outerBox1"
            style={{ cursor: isLocked ? 'not-allowed' : 'pointer' }}
             onClick={() => {
              handleViewClick(index, props?.activeItem?.sectionData?.data?.progressPercent, props?.data._id);
            }}
          >
            <Box className="innerBox" style={{gap: isMobile ?  '' : "30px"}}>
              <Box className="image-box" style={{backgroundColor: isMobile && "rgba(176, 190, 197, 0.31)"}}>
                {isLocked ? (
                  <LockIcon style={{ fontSize: '30px', color: '#9e9e9e' }} />
                ) : (
                  <VectorImage alt="Vector arrow" />
                )}
              </Box>
              <Box style={{flex: '1'}}>
                <Box className="content-box">
                  <p className={classes.genustext} sx={{ m: 0, mb: 1 }}>
                    {props?.data?.title?.en}
                  </p>
                </Box>
              </Box>
              <Box className="button-box">
                {isLocked ? (
                  <Box style={{ display: 'flex', alignItems: 'center', gap: '6px', marginLeft: 'auto', color: '#9e9e9e' }}>
                    <LockIcon style={{ fontSize: '20px' }} />
                    <Typography variant="inherit" style={{ fontWeight: 500 }}>{t('Locked')}</Typography>
                  </Box>
                ) : (
                  <>
                    <Box style={{width: isMobile ? 'unset' : '80%'}}>
                      {props.data.sectionPercent <=99 && !isMobile && <Box>
                        <LinearProgressWithLabel value={props.data.sectionPercent} width={20}/>
                      </Box>}
                      {props.data.sectionPercent > 99 && !isMobile && <Box className={classes.completedPercentageDiv}>
                        <GreenTick/>
                        <Typography variant="inherit" className={classes.completedPercentageText}>{`${Math.round(props.data.sectionPercent)}`}% {t('Completed')}</Typography>
                      </Box>}
                    </Box>
                    <Box className="minutes-read" style={{width: isMobile ? 'unset' : '40%'}}>
                      <AccessTimeIcon className={classes.readTimeText}/>
                      <Typography variant="inherit">{formatReadTime(props?.data?.sectionReadTimeCount)}</Typography>
                    </Box>
                  </>
                )}
              </Box>
              {isMobile && !isLocked &&
                <Box className={classes.sectionPercentDiv}>
                  <Button className={classes.selfLearning} variant="contained">
                    {props.data.sectionPercent <=99 && isMobile && <Box style={{display: 'flex', gap: '6px'}}>
                      <LinearProgressCircular value={props.data.sectionPercent} width={20}/>
                      <Typography variant="inherit" className={classes.completedPercentageText}>{`${Math.round(props.data.sectionPercent)}`}% {t('Completed')}</Typography>
                    </Box>}
                    {props.data.sectionPercent > 99 && isMobile && <Box className={classes.sectionPercentDiv}>
                      <GreenTick/>
                      <Typography variant="inherit" className={classes.completedPercentageText}>{`${Math.round(props.data.sectionPercent)}`}% {t('Completed')}</Typography>
                    </Box>}
                  </Button>
                </Box>
              }
              {!isMobile && <ChevronRightIcon style={{fill: '#0000008A', marginRight: '20px'}}/>}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
}

 function LinearProgressWithLabel({ value = 0 }) {
  const t = useTranslations();
  const theme = useTheme();
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));
  const overallProgress = Math.round(value);

  return (
    <Box width="100%" display="flex" alignItems="center" sx={{ gap: isMobile ? "6px" : '10px', justifyContent: isMobile && 'center' }}>
      {overallProgress <= 99 ? (
        <>
          <Box width={isMobile ? "18px" : "24px"}>
            <CircularProgressbar value={overallProgress} styles={{ path: { stroke: isMobile ? theme?.primaryFontText :theme?.primaryColor, strokeWidth: '10px' } }}/>
          </Box>
          <Typography variant="inherit" sx={{ display: 'flex', color: '#000000DE' }}>
            {overallProgress}% {t('Completed')}
          </Typography>
        </>
      ) : (
        <Box style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
          {isMobile ? <Box component="img" src={whiteTick} alt="Completed" /> : <GreenTick/>}
          <Typography variant="inherit" style={{ color: isMobile ? '#fff' : '#2E7D32', fontWeight: '600'}}>{overallProgress}% {t('Completed')}</Typography>
        </Box>
      )}
    </Box>
  );
}

function LinearProgressCircular({ value = 0 }) {
  const theme = useTheme();
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));
  const overallProgress = Math.round(value);

  return (
    <Box>
      {overallProgress <= 99 && (
        <>
          <Box width={isMobile ? "18px" : "24px"}>
            <CircularProgressbar value={overallProgress} styles={{ path: { stroke: isMobile && theme?.primaryColor, strokeWidth: '10px' } }}/>
          </Box>
        </>
      ) }
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
    value: PropTypes.number.isRequired,
};

LinearProgressCircular.propTypes = {
    value: PropTypes.number.isRequired,
};

export { LinearProgressWithLabel, LinearProgressCircular };